/**
 * Whether a search/source snippet may be attached as an evidence reference in the
 * product being edited. Approved Products (reports) are searchable and savable to
 * the Source Package, but must not be cited as references in another product —
 * except collection IIRs, which are intelligence inputs and remain citable.
 */
export function isProductReportSource({docSourceType, reportId, openTargetKind, localId, productType} = {}) {
    // IIR segments are citable even though they come from the report store.
    if (typeof productType === 'string' && productType.trim().toLowerCase() === 'iir') {
        return false;
    }

    if (reportId != null && String(reportId).length > 0) {
        return true;
    }

    const type = typeof docSourceType === 'string' ? docSourceType.trim().toUpperCase() : '';
    if (type === 'REPORT' || type === 'REPORTS' || type === 'REPORT_SEGMENT') {
        return true;
    }

    if (openTargetKind === 'report_segment') {
        return true;
    }

    if (typeof localId === 'string' && localId.startsWith('r:')) {
        return true;
    }

    return false;
}
